import { render, staticRenderFns } from "./PopupDoctorList.vue?vue&type=template&id=70006aee&"
import script from "./PopupDoctorList.vue?vue&type=script&lang=ts&"
export * from "./PopupDoctorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports